<template>
    <div>
        <slot name="trigger" :show="show"></slot>
        <transition name="modal" v-cloak>
            <div v-if="showModal" class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <div class="modal-close-btn-wrapper red-bg">
                            <button class="modal-default-button" @click="close()">&times;</button>
                        </div>
                        <div class="modal-header">
                            <h3>{{ title }}</h3>
                        </div>
                        <div class="modal-body">
                            <slot :close="close"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
        },
        data: function() {
            return  {
                showModal: false
            }
        },
        methods: {
            show() {
                this.showModal = true;
            },

            close() {
                this.showModal = false;
            }
        },
        watch: {
            showModal: function() {
                this.$emit('toggled', this.showModal);
            }
        },
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100vh;
        background-color: rgba(0, 0, 0, .2);
        display: table;
        transition: opacity .4s ease;
        overflow-y: scroll;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 80vw;
        min-width: 330px;
        max-width: 400px;
        margin: 0 auto;
        padding: 1rem;
        background-color: transparent;
    }

    .modal-close-btn-wrapper {
        height: 0;
        text-align: end;
    }

    .modal-close-btn-wrapper button {
        color: #F4F7F1;
        background-color: #E15F60;
        border: none;
        margin-top: 4px;
        margin-right: 8px;
    }

    .modal-header {
        height: 6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #E15F60;
        border-radius: 15px 15px 0 0;
    }

    .modal-header h3 {
        margin: 0;
        color: #F4F7F1;
        text-align: center;
    }

    .modal-body {
        padding: 1rem;
        background-color: #F4F7F1;
        border-radius: 0 0 15px 15px;
    }

    .modal-footer {
        text-align: center;
        background-color: #F4F7F1;
    }

    .modal-footer p {
        font-size: 10px;
        font-color: #eee;
        font-family: Helvetica;
        font-style: italic;
        padding: 10px 20px;
    }

    .modal-enter {
       opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }
</style>
